import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editScreen,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  MultiViewCalenderFilterCell,
  BooleanFlagFilterCell,
  GridFlag,
}) => {
  const dataColumns = [
    {
      field: 'DataType',
      title: 'Type',
      editable: false,
      show: true,
      width: '250px',
      className: 'edit-link',
      minResizableWidth: 50,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editScreen(props.dataItem);
          }}
        >
          {props.dataItem?.DataType}
        </td>
      ),
    },
    {
      field: 'BaseType',
      title: 'Base Type',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.BaseType}</td>,
    },
    {
      field: 'Label',
      title: 'Label',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.Label}</td>,
    },
    {
      field: 'Placeholder',
      title: 'Place Holder',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.Placeholder}</td>,
    },
    {
      field: 'UiControl',
      title: 'Ui Control',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.UiControl}</td>,
    },
    {
      field: 'DefaultValue',
      title: 'Default Value',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.DefaultValue}</td>,
    },
    {
      field: 'HelpText',
      title: 'Help Text',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.HelpText}</td>,
    },
    {
      field: 'Regex',
      title: 'Regex',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.Regex}</td>,
    },
    {
      field: 'MinLen',
      title: 'Min Length',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.MinLen}</td>,
    },
    {
      field: 'MaxLen',
      title: 'Max Length',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.MaxLen}</td>,
    },
    {
      field: 'MinValue',
      title: 'Min Value',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.MinValue}</td>,
    },
    {
      field: 'MaxValue',
      title: 'Max Value',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: (props) => <td>{props?.dataItem?.MaxValue}</td>,
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'CreatedBy',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'CreatedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'ModifiedBy',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'ModifiedDate',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ModifiedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
